import theme from '../../../lib/theme';
import { IconProps } from './Icon';

const { colors, font, animations } = theme;

export default ({
  brand = 'sas',
  container = true,
  color,
  size,
  rotateIcon,
}: IconProps) => {
  const _size = !size
    ? '1.25em'
    : typeof size === 'string'
    ? font[size]
    : `${size}em`;

  const _sizeContainer = !size
    ? '1em'
    : typeof size === 'string'
    ? font[size]
    : `${size}em`;

  return {
    materialIcon: {
      fontFamily: 'Material Icons',
    },
    icon: {
      verticalAlign: 'middle',
      fontStyle: 'normal',
      display: 'inline-block',
      lineHeight: 1,
      textTransform: 'none',
      letterSpacing: 'normal',
      whiteSpace: 'nowrap',
      fontSize: `${_size} !important`,
      width: `${container ? _sizeContainer : '1em'} !important`,
      height: `${container ? _sizeContainer : '1em'} !important`,
      fill: !color ? 'currentColor' : colors[brand][color] || colors[color],
      color: !color ? 'currentColor' : colors[brand][color] || colors[color],
      textDecoration: 'none',
      animation: rotateIcon ? `2000ms ${animations.spin} linear` : 'none',
      animationIterationCount: rotateIcon ? 'infinite' : 'none',
    },
  };
};
